import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-0 flex items-center p-0"
}
const _hoisted_2 = { class: "flex items-center shrink-0" }
const _hoisted_3 = {
  key: 0,
  class: "w-4 h-4 bg-gray-100 rounded-full"
}
const _hoisted_4 = {
  key: 1,
  class: "w-4 h-4 bg-blue-400 rounded-full"
}
const _hoisted_5 = {
  key: 2,
  class: "w-4 h-4 border border-secondary rounded-full"
}
const _hoisted_6 = { class: "flex flex-col grow" }
const _hoisted_7 = { class: "text-base font-normal antialiased text-gray-400 flex mb-1 mt-1" }
const _hoisted_8 = { class: "flex-grow leading-5 antialiased" }
const _hoisted_9 = { class: "text-base font-medium antialiased leading-5 text-gray-800" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-8",
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20.029 20.4773L14.5631 25.9432C14.2995 26.2068 13.8721 26.2068 13.6085 25.9432L12.971 25.3057C12.7079 25.0425 12.7073 24.616 12.9699 24.3522L17.3017 20L12.9699 15.6478C12.7073 15.384 12.7079 14.9575 12.971 14.6943L13.6085 14.0568C13.8721 13.7932 14.2995 13.7932 14.5631 14.0568L20.029 19.5227C20.2926 19.7863 20.2926 20.2137 20.029 20.4773Z",
      fill: "#E5E7EB"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.data)
    ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: '/bookings/' + _ctx.data.id,
          class: "flex w-full gap-x-4 no-underline py-1.5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.data?.bookingStatus === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                : _createCommentVNode("", true),
              (_ctx.data?.bookingStatus === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : _createCommentVNode("", true),
              (_ctx.data?.bookingStatus === 1 || !_ctx.data?.bookingStatus)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex-shrink-0 w-1 self-stretch mr-1", _ctx.getBookingHeaderColor(_ctx.data?.bookingHeader)])
                }, null, 2),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.data?.bookingHeader.toUpperCase()) + " - " + _toDisplayString(_ctx.getRemark(_ctx.data)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.data?.bookingTitle), 1)
            ]),
            _hoisted_10
          ]),
          _: 1
        }, 8, ["to"])
      ]))
    : _createCommentVNode("", true)
}